import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supported-browsers',
  templateUrl: './supported-browsers.component.html',
  styleUrls: ['./supported-browsers.component.scss']
})
export class SupportedBrowsersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
